import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'
import { account } from './account'
import layout from '@/stores/layout'
import area from '@/stores/area'
import menu from '@/stores/menu'
import multipleTab from '@/stores/multipleTab'

export { account, layout, area, menu, multipleTab }
export default createPinia().use(piniaPersist)
